(function($) {
  'use strict';

  var init = {
    dom: function() {
      this.menuEls = {
        $button: $('[data-js-hook="menu-toggle"]'),
        $menu: $('#nav')
      };

      this.petPolicy = {
        $button: $('#pet-policy'),
        $flyout: $('#pet-policy-flyout')
      };

      this.$pageWrap = $('.page__wrap');
      this.$utilityBar = $('#utility-bar');
      this.$header = $('#header');
      this.$dummyHeader = $('#dummyHeader');
      this.$stickyHeader = $('#sticky-header');
      this.$headerDummy = $('#headerDummy');
      this.$rotator = $('[data-js-hook="rotator"]');
      this.$sameHeight = $('[data-same-height]').children();
      this.$unitMixItems = $('.unit-mix__stat');

      this.$tabs = $('[data-tabs]');
    },

    definitions: {
      headerHeight: 0
    },

    menu: function() {
      this.menuEls.$button.click(function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-open');
      });

      $('a', this.menuEls.$menu).click(function() {
        $('body').toggleClass('menu-open');
      });
    },

    dummyHeader: function() {
      var self = this;
      $(window).on('load resize', function() {
        self.$dummyHeader.height(self.$header.outerHeight());
      });
    },

    stickyHeader: function() {
      var self = this;

      if (jcms.settings.stickyNav) {
        $(window).on('scroll load', function() {
          if (!self.$header.data('open') && $(window).scrollTop() > self.$pageWrap.offset().top) {
            self.$header.data('open', true);
            $('body').addClass('stickynav-active');
          }
          else if (self.$header.data('open') && $(window).scrollTop() <= self.$pageWrap.offset().top) {
            self.$header.data('open', false);
            $('body').removeClass('stickynav-active');
          }
        });
      }
    },

    infieldLabels: function() {
      this.$infieldLabels.each(function() {
        var self = $(this);
        var target = $(this).attr('for');
        var input = $('#' + target);
        input.on('focus', function() {
          if (!$(this).val()) {
            self.addClass('focus');
          }
        });
        input.on('keyup input', function() {
          if ($(this).val()) {
            self.removeClass('focus');
            self.addClass('active');
          }
          else {
            self.removeClass('active');
            self.addClass('focus');
          }
        });
        input.on('blur', function() {
          if (!$(this).val()) {
            self.removeClass('focus');
          }
        });
      });
    },

    pickadate: function() {
      var self = this;
      if (this.$datePicker.length) {
        this.$datePicker.on('mousedown', function(e) {
          e.preventDefault();
        }).pickadate({
          container: 'body',
          format: 'mmm d, yyyy',
          disable: [
            {from: [0, 0, 0], to: new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24)}
          ],
          onRender: function() {
            self.$datePicker.removeAttr('aria-expanded');
            $($(this)[0].$root[0]).find('[aria-activedescendant]').removeAttr('aria-activedescendant');
          },
          onSet: function(thingSet) {
            var label = $(this)[0].$node.attr('id');
            label = $('[for=' + label + ']');
            if (thingSet.select !== undefined) {
              label.addClass('active');
            }
            else {
              label.removeClass('active');
            }
          }
        });
      }
    },

    execPetPolicy: function() {
      var self = this;
      var policyCloserTimeout;

      this.petPolicy.$flyout.mouseenter(function() {
        clearTimeout(policyCloserTimeout);
      }).mouseleave(function() {
        self.petPolicy.$button.removeClass('header__toolbar-content--active-pet');
        self.petPolicy.$flyout.fadeOut(100);
      });

      this.petPolicy.$button.click(function(e) {
        e.preventDefault();
        $(this).addClass('header__toolbar-content--active-pet');
        self.petPolicy.$flyout.fadeToggle(100);
      }).mouseleave(function(e) {
        var $this = $(this);

        policyCloserTimeout = setTimeout(function() {
          $this.removeClass('header__toolbar-content--active-pet');
          self.petPolicy.$flyout.fadeOut(100);
        }, 30);
      });
    },

    imageModal: function() {
      var $triggers = $('[data-fancybox],[target="video"],[target="embed"],[target="popup"]');

      $triggers.each(function() {
        var url = $(this).attr('href');
        var target = $(this).attr('target');
        var wistia = url.match(/wistia/);

        if ((target === 'embed' || target === 'popup') && wistia) {
          $(this).attr('data-type', 'iframe');

          if (!$(this).attr('data-src')) {
            $(this).attr('data-src', url).attr('href', 'javascript:void(0)');
          }
        }

        if (wistia) {
          $(this).data('as-video', 1);
        }
      });

      $triggers.fancybox(jonahConfig.fancyboxSettings);
    },

    rotators: function() {
      this.$rotator.each(function() {
        var navType = $(this).data('nav');
        var controlNav = navType === 'control' ? true : false;
        var directionNav = navType === 'direction' ? true : (navType ? false : true);
        $(this).flexslider({
          controlNav: controlNav,
          directionNav: directionNav,
          start: function(slider) {
            if (slider.count < 2) {
              if (typeof slider.controlNavScaffold != 'undefined') {
                slider.controlNavScaffold.remove();
              }
              if (slider.directionNav && typeof slider.directionNav[0] != 'undefined') {
                $(slider.directionNav[0]).closest('ul').remove();
              }
            }
          }
        });
      });
    },

    lazyImages: function() {
      var myLazyLoad = new LazyLoad();
      var myLazyLoadBG = new LazyLoad({
        elements_selector: ".lazy"
      });
    },

    getOffset: function($element) {
      const offset = Math.ceil($element.offset().top);
      if (jcms.settings.stickyNav) {
        if (jcms.settings.stickyNav == 'desktop_only' && $(window).width() <= 808) {
          return offset;
        }
        else {
          return init.$header.length ? Math.ceil(offset - init.definitions.headerHeight) : offset;
        }
      }
    },

    hashScroll: function() {
      var self = this;

      $('a[href^="#"], a[href^="/#"]').not('[href="#"]').click(function(e) {
        e.preventDefault();

        var dest = $(this).attr('href');
        var $dest = $(dest.replace('/#', '#').replace(/^\/|\/$/g, ''));

        if ($dest.length) {
          let offset = init.getOffset($dest);
          $('html,body').animate({
            scrollTop: offset
          }, 'slow', function() {
            // Run again just in case the header height changed
            offset = init.getOffset($dest);
            $('html,body').animate({
              scrollTop: offset
            }, 'fast');
          });
        }
        else {
          window.location.href = $(this).attr('href');
        }
      });

      $(window).on('load', function() {
        if (typeof window.location.hash != 'undefined') {
          let hash = window.location.hash.replace(/^\/|\/$/g, '');
          let $hash = $(hash);

          if ($hash.length && $hash.is(':visible')) {
            let offset = init.getOffset($hash);

            setTimeout(function() {
              $('html,body').animate({
                scrollTop: offset
              });
            }, 'slow', function() {
              // Run again just in case the header height changed
              offset = init.getOffset($hash);
              $('html,body').animate({
                scrollTop: offset
              }, 'fast');
            });
          }
        }
      });
    },

    osCheck: function() {
      var OSName = "Unknown OS";
      if (navigator.appVersion.indexOf("Win") != -1) {
        OSName = "pc";
      }
      if (navigator.appVersion.indexOf("Mac") != -1) {
        OSName = "mac";
      }
      if (navigator.appVersion.indexOf("X11") != -1) {
        OSName = "unix";
      }
      if (navigator.appVersion.indexOf("Linux") != -1) {
        OSName = "linux";
      }
      $('html').addClass('os-' + OSName);
    },

    sameHeight: function() {
      var self = this;
      $(window).on('load resize', function() {
        var newHeight = 0;
        self.$sameHeight.height('');

        self.$sameHeight.each(function() {
          if (self.$sameHeight.height() > newHeight) {
            newHeight = self.$sameHeight.height();
          }
        });

        self.$sameHeight.height(newHeight);
      });
    },

    eventTracker: function() {
      $(document).on('click', '[data-event-tracking]', function() {
        var action = $(this).attr('data-event-action') ? $(this).attr('data-event-action') : 'click';
        var category = $(this).attr('data-event-category');
        var label = $(this).attr('data-event-label');
        var value = $(this).attr('data-event-value');

        event_tracker(category, action, label, value);
      });
    },

    initModal: function() {
      jutil.bindModal();
    },

    initTracking: function() {
      $.getScript('/jonahlytics/dist/jonahlytics.min.js', function() {
        Jonahlytics.init({
          leaseUrl: typeof jcms.lease_url != 'undefined' ? jcms.lease_url : null,
          mapUrl: typeof jcms.map_settings.map_url != 'undefined' ? jcms.map_settings.map_url : null,
        });
      });
    },

    setStyles: function() {
      const body = $('body').get(0);
      let initHeight = jcms.header_layout !== 2 ? init.$header.outerHeight() : 0;
      body.style.setProperty('--jd-header-init-height', initHeight + 'px');

      $(window).on('load scroll resize', function() {
        setTimeout(function() {
          init.definitions.headerHeight = jcms.header_sticky ? init.$header.outerHeight() : 0;
          body.style.setProperty('--jd-header-height', init.definitions.headerHeight + 'px');

          if (init.$utilityBar.length) {
            body.style.setProperty('--jd-utility-height', Math.ceil(init.$utilityBar.outerHeight()) + 'px');
          }
        }, 150);
      });
    },

    unitMix: function() {
      $(window).on('load resize', function() {
        init.$unitMixItems.each(function(index, element) {
          element.style.setProperty('--jd-stat-width', $(this).outerWidth() + 'px');
        });
      });
    },

    fancybox: function() {
      jutil.bindFancybox();
    },

    tabs: function() {
      if (this.$tabs.length) {
        this.$tabs.each((index, item) => {
          let $tabs = $(item);
          let $containers = $('[data-tab-container="' + $tabs.data('tabs') + '"]');
          let tabber = new jdTabs($tabs);

          tabber.onTab(function($tab){
            let $container = $containers.filter('[data-tab="' + $tab.data('tab') + '"]');

            if ($container.length) {
              $containers.hide();
              $container.show();
            }
          });
        });
      }
    },

    ready: function() {
      $('html').removeClass('no-js').addClass('js');
      this.dom();
      this.menu();
      this.execPetPolicy();
      this.imageModal();
      this.dummyHeader();
      this.stickyHeader();
      this.rotators();
      this.lazyImages();
      this.osCheck();
      this.sameHeight();
      this.eventTracker();
      this.initModal();
      this.initTracking();
      this.setStyles();
      this.hashScroll();
      this.unitMix();
      this.fancybox();
      this.tabs();
    }
  };

  $(function() {
    init.ready();
  });

})(jQuery);


const maxZ = function(not) {
  'use strict';

  let zMax = 2000000000;

  return Math.max.apply(null,
    $.map($('body *'), function(e, n) {

      if (not) {
        if ($(e).filter(not).length) {
          return 0;
        }
      }

      if ($(e).css('position') != 'static') {
        let z = parseInt($(e).css('z-index')) || 1;

        /**
         * Disallow z-indexes over 2 billion. Lots of
         * third-party vendors use the max z-index
         * to ensure their widgets are always on
         * top. We will reset them down to 2
         * billion to ensure Jonah menus
         * and lightboxes can always be
         * on top.
         */
        if (z >= zMax) {
          z = zMax;
          $(e).css('z-index', z);
        }

        return z;
      }
    }));
};
